if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.usesThumbnailDesktopLayout = this.dataset.desktopLayout?.includes('thumbnail');

        if (this.elements.viewer) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        }

        if (this.usesThumbnailDesktopLayout) {
          this.initDesktopViewerNavigation();
        }

        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.usesThumbnailDesktopLayout && this.mql.matches) this.removeListSemantic();
      }

      getMediaSlides() {
        return Array.from(this.elements.viewer.querySelectorAll('li[data-media-id]'));
      }

      initDesktopViewerNavigation() {
        const prevButton = this.elements.viewer?.querySelector('button[name="previous"]');
        const nextButton = this.elements.viewer?.querySelector('button[name="next"]');
        if (!prevButton || !nextButton) return;

        const onNav = (direction) => (event) => {
          if (!this.mql.matches) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const mediaItems = this.getMediaSlides();
          if (mediaItems.length < 2) return;

          const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
          const currentIndex = activeIndex === -1 ? 0 : activeIndex;
          let nextIndex = currentIndex + direction;

          if (nextIndex < 0) nextIndex = mediaItems.length - 1;
          if (nextIndex >= mediaItems.length) nextIndex = 0;

          this.setActiveMedia(mediaItems[nextIndex].dataset.mediaId, false);
        };

        prevButton.addEventListener('click', onNav(-1), true);
        nextButton.addEventListener('click', onNav(1), true);

        const keepButtonsEnabled = () => {
          if (!this.mql.matches) return;

          if (this.getMediaSlides().length > 1) {
            prevButton.removeAttribute('disabled');
            nextButton.removeAttribute('disabled');
          }
        };

        keepButtonsEnabled();
        this.mql.addEventListener('change', keepButtonsEnabled);

        const buttonObserver = new MutationObserver(keepButtonsEnabled);
        buttonObserver.observe(prevButton, { attributes: true, attributeFilter: ['disabled'] });
        buttonObserver.observe(nextButton, { attributes: true, attributeFilter: ['disabled'] });
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`li[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('li[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.getMediaSlides().forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || !this.usesThumbnailDesktopLayout) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
